var _defs, _line, _line2, _circle, _polyline, _polyline2, _circle2, _path, _polyline3, _polyline4, _polyline5, _polyline6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.04,
    y1: 69.19,
    x2: 178.96,
    y2: 69.19
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 89.95,
    y1: 91.4,
    x2: 166.05,
    y2: 91.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 128,
    cy: 155,
    r: 37.45,
    transform: "translate(-45.5 256.53) rotate(-80.78)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "135.04 193.29 155.93 237.63 161.64 214.31 183.47 224.03 160.32 175.7"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "120.96 193.29 100.06 237.63 94.36 214.31 72.53 224.03 96.03 175.7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 128,
    cy: 155,
    r: 17.56
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94,180H28a10,10,0,0,1-10-10V28.37a10,10,0,0,1,10-10H228a10,10,0,0,1,10,10V170a10,10,0,0,1-10,10H162.35"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "38.12 64.87 38.12 37.69 65.3 37.69"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "190.7 37.69 217.88 37.69 217.88 64.87"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "217.88 133.45 217.88 160.63 190.7 160.63"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "65.3 160.63 38.12 160.63 38.12 133.45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualification);
export default __webpack_public_path__ + "static/media/qualification.615dbe546291978cc62a23933bcddd38.svg";
export { ForwardRef as ReactComponent };